// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"49":"consumption","122":"bim","179":"main","312":"blank"}[chunkId] || chunkId) + "." + {"49":"4fdd8fda","122":"ad01b881","179":"6a9929b8","312":"87ff55cc","432":"777a07dc","948":"6c2c557a"}[chunkId] + ".js";
};